<template>
  <NodeEditor
    :node="value"
    @editFinish="$_savingOptionsMixin_onEditFinish"
    @delete="$_savingOptionsMixin_onDelete"
  >
    <EditChartHeader :value="value" />
    <div class="vertical-bar-chart-container">
      <svg ref="chart" class="pigeondoc-chart vertical-bar-chart"></svg>
    </div>
  </NodeEditor>
</template>

<script>
import EditChartHeader from '../ChartHeader/EditChartHeader.vue';
import NodeEditor from '../NodeEditor/NodeEditor.vue';

import verticalBarChartMixin from './verticalBarChartMixin.js';
import savingOptionsMixin from '../NodeEditor/Mixins/savingOptionsMixin.js';

export default {
  name: 'EditVerticalBarChart',
  mixins: [verticalBarChartMixin, savingOptionsMixin],
  components: {
    EditChartHeader,
    NodeEditor,
  },
};
</script>
